import { render, staticRenderFns } from "./ErrorPaymentBanner.vue?vue&type=template&id=d0423964&"
import script from "./ErrorPaymentBanner.vue?vue&type=script&lang=ts&"
export * from "./ErrorPaymentBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports